export const config = {
  title: "Red Berm",
  meta: {
    description:
      "Red Berm is a Pasadena-based landscape design studio creating sculptural, energy-conscious outdoor spaces. Services include custom landscape plans, hardscape & construction details, irrigation and fire-safety plans, LEED/HOA/city compliance, and edible & pollinator gardens.",
    keywords: [
      "Pasadena landscape design",
      "landscape architect Pasadena",
      "hardscape plans",
      "irrigation plans",
      "fire safety landscape",
      "LEED HOA city compliance",
      "edible gardens",
      "pollinator gardens",
      "Red Berm"
    ],
    author: "Red Berm",
    canonicalUrl: "https://redberm.com/",
  },
  sections: {
    header: {
      businessName: "Red Berm",
    },
    sectionB: {
      heroTitle: "Red Berm",
      heroSubtitle: "Landscape Design for Flow, Form, and Feeling",
      learnAboutText: "Request a Consultation",
      phoneNumber: "3232061595",
      phoneLabel: "(323) 206‑1595",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1324918160/photo/professional-gardener-trimming-hedge.jpg?s=612x612&w=0&k=20&c=zumBbqam7P2pNpoGMrca4RhZGWW7zfRDUDE2zqABJTs=",
      cardData: [
        {
          title: "Landscape Design",
          description:
            "Concept-to-plan residential & boutique commercial landscapes crafted as living art.",
        },
        {
          title: "Hardscape & Details",
          description:
            "Patios, walkways, walls, lighting layout, and construction details coordinated to code.",
        },
        {
          title: "Irrigation & Compliance",
          description:
            "Water-wise irrigation, fire-safety considerations, and LEED/HOA/city submittals.",
        },
      ],
      description:
        "Based in Pasadena and serving Greater LA, Red Berm designs timeless, sustainable spaces with sculptural moments and a strong sense of movement and energy.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Plans and packages tailored to your site, style, and local requirements.",
      cards: [
        {
          title: "Custom Landscape & Planting Plans",
          description:
            "Site analysis, planting palettes, and phased design packages that fit your budget and goals.",
          imageSrc:
            "https://redberm.com/wp-content/uploads/2025/07/image-10.png",
          imageAlt: "Custom planting palette and site plan",
        },
        {
          title: "Irrigation & Fire-Safety Plans",
          description:
            "Efficient irrigation layouts and defensible‑space considerations for hillside & urban sites.",
          imageSrc:
            "https://redberm.com/wp-content/uploads/2025/08/20250727_155601484_iOS.png",
          imageAlt: "Efficient irrigation and drought‑tolerant garden",
        },
        {
          title: "Hardscape & Construction Details",
          description:
            "Patios, paths, stairs, walls, grading notes, and material schedules ready for installers.",
          imageSrc:
            "https://redberm.com/wp-content/uploads/2025/07/Design-Only-Landscaping-with-Soul-Science.jpg",
          imageAlt: "Modern hardscape with path and patio",
        },
      ],
      otherServicesTitle: "Also Available",
      otherServicesList: [
        "LEED, HOA & City Compliance Submittals",
        "Edible & Pollinator Gardens",
        "Water Features & Lighting Concepts",
        "Sustainable Material Reuse",
        "3D Rendering & Visualization",
      ],
    },
    sectionD: {
      aboutTitle: "About Red Berm",
      aboutImage: {
        src:
          "https://redberm.com/wp-content/uploads/2025/08/7.jpg",
        alt: "Sculptural landscape with movement and texture",
      },
      aboutText: [
        "Red Berm designs with the natural flow of a site—treating landscape as living art that’s felt, not just seen.",
        "Our philosophy centers on movement, energy, and the psychology of space to create environments that are visually compelling and emotionally restorative.",
      ],
    },
    sectionE: {
      profileImage: "https://redberm.com/wp-content/uploads/2025/07/Logo-Red_Berm-removebg-preview-e1753835502913-1.png",
      profileAlt: "Red Berm Logo",
      businessName: "Red Berm",
      contact: {
        phone: "3232061595",
        phoneLabel: "(323) 206‑1595",
        email: "Liz@RedBerm.com",
        website: "https://redberm.com/",
        address: "Pasadena, CA 91101",
      },
      socialMedia: {
        instagram: "https://www.instagram.com/redberm/",
        houzz:
          "https://www.houzz.com/professionals/landscape-architects-and-landscape-designers/red-berm-pfvwus-pf~1762015607"
      },
    },
    sectionF: {
      address: "Pasadena, CA 91101",
      googleMapsEmbedUrl:
        "https://www.google.com/maps?q=Pasadena,+CA+91101&output=embed",
    },
  },
};

export default config;
